export default {
    convertQueryStringToObj(url) {
        if (url && url.length) {
            const queryStringIndex = url.indexOf("?")

            if (queryStringIndex >= 0) {
                const queryStringUrl = url.substring(queryStringIndex + 1)
                return Object.fromEntries(new URLSearchParams(queryStringUrl))
            }
        }

        return null
    },
    GetQueryStringObjFromUrl(url) {
        if (url) {
            let newQueryStringObj = this.convertQueryStringToObj(url)

            if (newQueryStringObj) {
                newQueryStringObj.time = Date.now()
                return newQueryStringObj
            }
        }

        return null;
    },
    getLocationInfoFromLocQueryString(locQueryString) {
      if (locQueryString) {
            //seatCode is optional
            // const locationPattern = /^(?<instituteCode>\w{1,20}).(?<branchCode>\w{1,20}).(?<floor>\d{1,2}).(?<placeCode>\w{1,30})(.(?<seatCode>\d{1,3}))?$/
            // const locationPattern = /^(?<instituteCode>\w{1,20}).(?<placeCode>(?<branchCode>\w{1,20}).(?<floor>\w{1,2}).\w{1,30})(.(?<seatNo>\d{1,3}))?$/

            const locationPattern = /(?<instituteCode>\w{1,20}).(?<branchCode>\w{1,20})(.(?<placeCode>(?<floor>\w{1,2}).\w{1,30}))?(.(?<seatNo>\d{1,3}[a-zA-Z]?))?/

            const locMatch = locQueryString.match(locationPattern)

            let locationInfo = locMatch ? locMatch.groups : null

            // add back branchCode into placeCode
            if (locationInfo && locationInfo.placeCode) {
                locationInfo.placeCode = locationInfo.branchCode + "." + locationInfo.placeCode
            }

            if (locationInfo && locationInfo.seatNo) {
                locationInfo = this.addSeatCodeToLocationInfo(locationInfo)
            }

            if (locationInfo) {
                return locationInfo
            }
        }

        return null
    },
    addSeatCodeToLocationInfo(locationInfo) {
        // https://192.168.10.100:8090/seatbooking/?loc=NLB.TRL.5.BloombergTerminal.1
        
        //SeatNo = 1
        //seatCode = TRL.5.BLoombergTerminal.1
        const seatCode = `${locationInfo.placeCode}.${locationInfo.seatNo}`;
        locationInfo.seatCode = seatCode;
        return locationInfo;
    },
    validateAreaQrCode(qrCode) {
        const queryStringObj = this.GetQueryStringObjFromUrl(qrCode);

        if (queryStringObj && queryStringObj.loc) {
            const locationInfo = this.getLocationInfoFromLocQueryString(queryStringObj.loc)

            if (locationInfo) {
                return locationInfo
            }
        }

        return null;
    }
}
